<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!isLoading">
        Изменения в ЕГРЮЛ ({{items.length}})
        <template v-for="item in topItems">
          <div>
            <b>{{formats.blank(item.updated, formats.formatDate)}}</b> {{item.value}}
          </div>
        </template>      
      </div>  
    </v-panel-title>
    <v-card-text v-show="isLoaded && items.length > 0" class="pt-0">
      <v-flex v-if="items.length===0">
      Данные не найдены.
      </v-flex>                
      <template v-for="item in lastItems">
        <div>
          <b>{{formats.blank(item.updated, formats.formatDate)}}</b> {{item.value}}
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import vPanelTitle from './PanelTitle'

  export default {
    name: 'v-records-panel',
    components: {vPanelTitle},
    mixins: [apimix],
    data: () => ({
      id: null,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      },
      records: {
        type: Array,
        default () {
          return []
        }
      }
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      },
      items () {
        return this.records
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          // this.fetchItems()
        }
      }
      // ,
      // getItems (id, cb) {
      //   const cbError = (e) => {
      //     this.isLoading = false
      //     this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о записях из ЕГРЮЛ '})
      //   }
      //   server.openApiGet(
      //     '/openapi/companies/' + id + '/records',
      //     cb,
      //     cbError)
      // },
      // fetchItems () {
      //   if (this.id && !this.isLoading) {
      //     this.items = []
      //     this.isLoading = true
      //     this.getItems(this.id, (data) => {
      //       this.items = data
      //       this.items.sort((a, b) => this.sortItems(a, b))
      //       this.isLoading = false
      //     })
      //   }
      // }
    }
  }

</script>


// WEBPACK FOOTER //
// RecordsPanel.vue?1bddc0db